import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface WidgetControl {
  title: string;
  icon?: string;
  disabled?: boolean;
  onClick?: () => any;
}

/**
 * `<labs-widget>` displays a widget with a title and header controls
 */
@Component({
  selector: 'labs-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetComponent {
  @Input() title: string;

  @Input() controls?: WidgetControl[];

  handleControlClick(control: WidgetControl) {
    if (control.onClick && !control.disabled) {
      control.onClick();
    }
  }
}
